/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrUrinaryGlucoseTypename = "PhrUrinaryGlucose" as const;

/**
 *
 * @export
 * @interface PhrUrinaryGlucose
 */
export interface PhrUrinaryGlucose {
  /**
   *
   * @type {string}
   * @memberof PhrUrinaryGlucose
   */
  autoMatic?: string;
  /**
   *
   * @type {string}
   * @memberof PhrUrinaryGlucose
   */
  manual?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrUrinaryGlucose
   */
  readonly __typename?: string;
}

export function PhrUrinaryGlucoseFromJSON(json: any): PhrUrinaryGlucose {
  return PhrUrinaryGlucoseFromJSONTyped(json, false);
}

export function PhrUrinaryGlucoseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrUrinaryGlucose {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrUrinaryGlucoseTypename,

    autoMatic: !exists(json, "auto_matic") ? undefined : json["auto_matic"],
    manual: !exists(json, "manual") ? undefined : json["manual"],
  };
}

export function PhrUrinaryGlucoseToJSON(object?: PhrUrinaryGlucose | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    auto_matic: value.autoMatic,
    manual: value.manual,
  };
}
